import { useAuthBearerFetch } from "matsuri-hooks"
import { useMemo } from "react"
import { ListingBigQueryTable, RoomKeyInformation } from "@/model/bigQueryInfo"
import { m2mCleaning } from "@/endpoints/m2m-cleaning"

// 引数に意図的にundefinedを明示する
export const useListingBigQueryTable = (
    token: string,
    cleaningId: string | undefined
) => {
    return useAuthBearerFetch<ListingBigQueryTable>(
        token,
        cleaningId ? m2mCleaning.cleanerV3.listBigQueryInfo() : null,
        {
            method: "POST",
            body: JSON.stringify({
                cleaningId
            })
        }
    )
}

export const useRoomKeyInformation = (
    token: string,
    cleaningId: string | undefined
): RoomKeyInformation | undefined => {
    const { data: listingBigQueryTable } = useListingBigQueryTable(
        token,
        cleaningId
    )

    const roomKeyInformation = useMemo(
        () =>
            listingBigQueryTable?.rows.filter(
                row => row.tableName === "room_key_information"
            )?.[0]?.row ?? undefined,
        [listingBigQueryTable]
    ) as RoomKeyInformation | undefined

    return roomKeyInformation
}
